import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getMyMenus } from '@/api/modules/system'

/**
 * 菜单数据定义（迁移自 pc/js/menu.js）
 * page_src 替换为 Vue Router 路由路径
 */
const MENU_DATA = [
  {
    page_name: '基础信息',
    page_list: [
      { page_name: '标签管理', path: '/base/tag-list', role_list: [1] },
      { page_name: '律师事务', path: '/base/office-list', role_list: [1, 2, 6] },
      { page_name: '人员信息', path: '/base/user-list', role_list: [1, 2, 5, 6] },
      { page_name: '顾问单位', path: '/base/consultant-unit-list', role_list: [1, 2, 3, 5] },
      { page_name: '委托单位', path: '/base/trust-office-list', role_list: [1, 2, 3] },
      { page_name: '委托人员', path: '/base/trust-user-list', role_list: [1, 2, 3] },
      // 隐藏菜单：律师通讯、通知公告（路由保留可直接访问 URL，如需恢复去掉注释即可）
      // { page_name: '律师通讯', path: '/base/lawyer-list', role_list: [1, 2, 3, 4, 5, 6] },
      // { page_name: '通知公告', path: '/base/notice-list', role_list: [1, 2, 3, 4, 5, 6] },
      { page_name: '更新日志', path: '/base/update-log', role_list: [1, 2, 3, 4, 5, 6] },
      { page_name: '模板管理', path: '/base/template-list', role_list: [1] },
      { page_name: '文书展示', path: '/base/doc-display-rule', role_list: [1] },
    ],
  },
  {
    page_name: '互动交流',
    page_list: [
      { page_name: '律师圈子', path: '/circle/lawyer-circle', role_list: [1, 2, 3, 4, 5, 6] },
    ],
  },
  {
    page_name: '案件处理',
    role_list: [1, 2, 3, 4, 5],
    page_list: [
      {
        page_name: '刑事待办',
        path: '/case/list',
        query: { case_type: '1' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '民事待办',
        path: '/case/list',
        query: { case_type: '2' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '行政待办',
        path: '/case/list',
        query: { case_type: '4' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '仲裁待办',
        path: '/case/list',
        query: { case_type: '5' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '非诉业务',
        path: '/case/list',
        query: { case_type: '7' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '全部待办',
        path: '/case/list',
        query: { case_type: '200' },
        role_list: [1, 2, 3, 4, 5],
      },
      {
        page_name: '我的案件',
        path: '/case/list',
        query: { case_type: '100' },
        role_list: [1, 2, 3, 4, 5],
      },
    ],
  },
  {
    page_name: '案件查询',
    role_list: [1, 2, 3, 4, 5, 6],
    page_list: [
      {
        page_name: '刑事案件',
        path: '/case/list',
        query: { total: '1', case_type: '301' },
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '民事案件',
        path: '/case/list',
        query: { total: '1', case_type: '302' },
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '行政案件',
        path: '/case/list',
        query: { total: '1', case_type: '304' },
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '仲裁业务',
        path: '/case/list',
        query: { total: '1', case_type: '305' },
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '非诉查询',
        path: '/case/list',
        query: { total: '1', case_type: '307' },
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '利益自查',
        path: '/case/conflict-check',
        role_list: [1, 2, 3, 4, 5, 6],
      },
    ],
  },
  {
    page_name: '财务管理',
    role_list: [1, 2, 3, 4, 5, 6],
    page_list: [
      {
        page_name: '电子签章',
        path: '/esign/management',
        role_list: [1, 2, 3, 4, 5, 6],
      },
      {
        page_name: '案件收款',
        path: '/finance/case-payment',
        role_list: [1, 2, 3, 4, 5, 6],
      },
    ],
  },
  {
    page_name: '数据看板',
    role_list: [1, 2, 6],
    page_list: [
      {
        page_name: '站点数据',
        path: '/bi/site-data',
        role_list: [2],
      },
      {
        page_name: '系统数据',
        path: '/bi/system-data',
        role_list: [1, 6],
      },
      {
        page_name: '高级看板',
        path: '/bi/advanced-dashboard',
        role_list: [1, 6],
      },
      {
        page_name: '操作日志',
        path: '/bi/operation-log',
        role_list: [1],
      },
      {
        page_name: '接口统计',
        path: '/bi/api-stats',
        role_list: [1],
      },
      {
        page_name: '日志管理',
        path: '/system/log-management',
        role_list: [1],
      },
      {
        page_name: '搜索引擎',
        path: '/search/engine',
        role_list: [1],
      },
    ],
  },
  {
    page_name: '系统设置',
    role_list: [1],
    page_list: [
      {
        page_name: '角色权限',
        path: '/system/role-perm',
        role_list: [1],
      },
      {
        page_name: '风控检测',
        path: '/system/risk-control',
        role_list: [1],
      },
    ],
  },
]

export const useMenuStore = defineStore('menu', () => {
  const menuList = ref(MENU_DATA)
  const activeMenuIndex = ref(0)
  const activeSubMenuIndex = ref(0)
  const sidebarCollapsed = ref(false)
  // DB 菜单驱动标记：true=侧边栏/路由守卫以 t_sys_menu 数据为准；false=降级内置菜单
  const menuFromDb = ref(false)
  const allMenuPaths = ref([])
  let dbLoadPromise = null

  /** 重置菜单状态（登录/退出时调用，清空缓存让新账号重新加载） */
  function reset() {
    menuList.value = MENU_DATA
    menuFromDb.value = false
    allMenuPaths.value = []
    dbLoadPromise = null
  }

  /** 从数据表加载当前用户菜单（空数据/失败/超时 时降级为内置菜单，不阻塞页面） */
  function loadMenusFromDb() {
    if (!dbLoadPromise) {
      const timeout = new Promise((resolve) => setTimeout(resolve, 5000))
      const doLoad = (async () => {
        try {
          console.log('[LSV] loadMenusFromDb: requesting...')
          const data = await getMyMenus({ _hideLoading: true })
          const menus = data?.menus || []
          console.log('[LSV] loadMenusFromDb: got', menus.length, 'groups')
          if (Array.isArray(menus) && menus.length > 0) {
            menuList.value = menus
            menuFromDb.value = true
            allMenuPaths.value = data?.all_paths || []
          } else {
            console.log('[LSV] loadMenusFromDb: empty, fallback builtin menus')
          }
        } catch (e) {
          // 接口异常/未登录：保持内置菜单降级
          console.warn('[LSV] loadMenusFromDb failed, fallback builtin menus:', e?.message || e)
        }
      })()
      dbLoadPromise = Promise.race([doLoad, timeout])
    }
    return dbLoadPromise
  }

  /** 当前用户可见的菜单路径集合（DB 模式下路由守卫使用） */
  function allowedPaths() {
    const paths = []
    for (const m of menuList.value) {
      for (const s of m.page_list || []) {
        if (s.path) paths.push(s.path)
      }
    }
    return paths
  }

  /** 设置激活菜单 */
  function setActiveMenu(menuIndex, subMenuIndex) {
    activeMenuIndex.value = menuIndex
    activeSubMenuIndex.value = subMenuIndex
    localStorage.setItem('activeMenuIndex', String(menuIndex))
    localStorage.setItem('activeSubMenuIndex', String(subMenuIndex))
  }

  /** 从 localStorage 恢复菜单状态 */
  function loadFromStorage() {
    activeMenuIndex.value = parseInt(localStorage.getItem('activeMenuIndex')) || 0
    activeSubMenuIndex.value = parseInt(localStorage.getItem('activeSubMenuIndex')) || 0
  }

  /** 切换侧边栏折叠状态 */
  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  /**
   * 根据当前路由路径查找并高亮对应菜单
   */
  function setActiveByRoute(routePath, routeQuery) {
    for (let i = 0; i < menuList.value.length; i++) {
      const menu = menuList.value[i]
      if (menu.page_list) {
        for (let j = 0; j < menu.page_list.length; j++) {
          const sub = menu.page_list[j]
          if (sub.path === routePath) {
            // 对于带 query 的路由（如案件列表），需要匹配 query 参数
            if (sub.query) {
              const queryMatch = Object.keys(sub.query).every(
                (key) => String(routeQuery[key]) === String(sub.query[key]),
              )
              if (queryMatch) {
                setActiveMenu(i, j)
                return
              }
            } else {
              setActiveMenu(i, j)
              return
            }
          }
        }
      }
    }
  }

  return {
    menuList,
    activeMenuIndex,
    activeSubMenuIndex,
    sidebarCollapsed,
    menuFromDb,
    allMenuPaths,
    loadMenusFromDb,
    allowedPaths,
    setActiveMenu,
    loadFromStorage,
    toggleSidebar,
    setActiveByRoute,
    reset,
  }
})
